import { HDAACCOUNTSARRAY } from 'constants/accouts'

type Props = {
  account?: string
  project: string
}

const LogoAccount = ({ project }: Props): JSX.Element => {
  const key = String(project || '').toLowerCase()
  const asset = HDAACCOUNTSARRAY.find((item) => item.project === key)

  // fallback: assume generic path exists at /accounts/generic/{project}/logo.png
  const logoPath =
    asset?.logo || `/accounts/generic/${encodeURIComponent(key)}/logo.png`
  const alt = asset?.alt || key || 'generic'

  return (
    <div className="flex justify-center items-center">
      <img src={logoPath} alt={alt} style={{ maxWidth: '100%' }} />
    </div>
  )
}

export default LogoAccount
